export default __webpack_public_path__ + "static/media/list-view.885742df.svg";